module.exports = __webpack_public_path__ + "img/chordMate.210ec1dd.png";